export class ArgumentError extends Error {
	public static readonly argumentExistsText = "The argument already exists";
	public static readonly argumentNotFoundText = "The argument could not be found";

	constructor(public parameter: string, message: string) {
		super(`${message}:${parameter}`);
		Object.setPrototypeOf(this, ArgumentError.prototype);
	}
}